// extracted by mini-css-extract-plugin
export default {"header":"Header_header__56UuC","main-image":"Header_main-image__xlzl+"};